module.exports = __webpack_public_path__ + "static/media/blate3bg.f4438ceb.png";